import React from 'react';
import PayrollHeader from '../features/payroll/components/PayrollHeader';
import StatCard from '../features/payroll/components/StatCard';
import PayrollTable from '../features/payroll/components/PayrollTable';
import PayrollEmptyState from '../features/payroll/components/PayrollEmptyState';
import PayrollLoadingState from '../features/payroll/components/PayrollLoadingState';
import { Calendar, CurrencyIcon, TrendingUp } from 'lucide-react';

const currentMonth = new Date().toLocaleString('default', { month: 'long' });
const avgNetSalary = 5750;

const Payroll = () => {
  const payrollData = [
    {
      "id": "1",
      "month": "January",
      "year": "2023",
      "grossSalary": 6500.00,
      "netSalary": 5525.00,
      "deductions": 975.00
    },
    {
      "id": "2",
      "month": "February",
      "year": "2023",
      "grossSalary": 6500.00,
      "netSalary": 5650.00,
      "deductions": 850.00
    }
  ];
  const isLoading = false;

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-purple-100 dark:bg-gradient-to-br dark:from-gray-900 dark:to-indigo-900/30 min-h-screen py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto space-y-6">
        <PayrollHeader currentMonth={currentMonth} avgNetSalary={avgNetSalary} />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 my-6">
          <StatCard
            title="Total Paid"
            value="$12,450"
            icon={CurrencyIcon}
            color="from-indigo-500 to-purple-500"
            darkColor="dark:from-indigo-600 dark:to-purple-600"
          />
          <StatCard
            title="Highest Month"
            value="June 2023"
            icon={TrendingUp}
            color="from-emerald-500 to-teal-500"
            darkColor="dark:from-emerald-600 dark:to-teal-600"
          />
          <StatCard
            title="YTD Earnings"
            value="$84,200"
            icon={Calendar}
            color="from-amber-500 to-orange-500"
            darkColor="dark:from-amber-600 dark:to-orange-600"
          />
        </div>

        {payrollData.length === 0 ? (
          <PayrollEmptyState />
        ) : (
          <PayrollTable payrollData={payrollData} />
        )}

        {isLoading && <PayrollLoadingState />}
      </div>
    </div>
  );
};

export default Payroll;
